import { createSlice } from "@reduxjs/toolkit";
import {
  getStakePlans,
  createStake,
  getStakes,
  breakStake,
  withdrawStake,
} from "./StakeActions";

const initialState = {
  stakeIsLoading: false,
  createStakeIsLoading: false,
  stakes: [],
  stake: {},
  stakePlanIsLoading: false,
  stakePlans: [], // for stakePlans array
  error: null,
  breakStakeLoading: false,
  breakStake: {},
  withdrawStakeLoading: false,
  withdrawStake: {},
};

const stakePlansSlice = createSlice({
  name: "stakePlans",
  initialState,
  reducers: {},
  extraReducers: {
    [getStakePlans.fulfilled]: (state, { payload }) => {
      state.stakePlanIsLoading = false;
      state.success = true;
      state.stakePlans = payload.data;
    },
    [getStakePlans.pending]: (state, { payload }) => {
      state.stakePlanIsLoading = true;
    },
    [getStakePlans.rejected]: (state, { payload }) => {
      state.stakePlanIsLoading = false;
      state.stakePlans = payload;
    },
    [createStake.fulfilled]: (state, { payload }) => {
      state.createStakeIsLoading = false;
      state.success = true;
      state.stake = payload.data;
    },
    [createStake.pending]: (state, { payload }) => {
      state.createStakeIsLoading = true;
    },
    [createStake.rejected]: (state, { payload }) => {
      state.createStakeIsLoading = false;
      state.stake = payload;
    },
    [getStakes.fulfilled]: (state, { payload }) => {
      state.stakeIsLoading = false;
      state.success = true;
      state.stakes = payload.data;
    },
    [getStakes.pending]: (state, { payload }) => {
      state.stakeIsLoading = true;
    },
    [getStakes.rejected]: (state, { payload }) => {
      state.stakeIsLoading = false;
      state.stakes = payload;
    },
    [breakStake.fulfilled]: (state, { payload }) => {
      state.breakStakeLoading = false;
      state.success = true;
      state.breakStake = payload.data;
    },
    [breakStake.pending]: (state, { payload }) => {
      state.breakStakeLoading = true;
    },
    [breakStake.rejected]: (state, { payload }) => {
      state.breakStakeLoading = false;
      state.breakStake = payload;
    },
    [withdrawStake.fulfilled]: (state, { payload }) => {
      state.withdrawStakeLoading = false;
      state.success = true;
      state.withdrawStake = payload.data;
    },
    [withdrawStake.pending]: (state, { payload }) => {
      state.withdrawStakeLoading = true;
    },
    [withdrawStake.rejected]: (state, { payload }) => {
      state.withdrawStakeLoading = false;
      state.withdrawStake = payload;
    },
  },
});

export default stakePlansSlice.reducer;
